// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareFlyOutStyles } from "@stoneage/Overrides/Components/ProductCompareFlyOut";
import { css } from "styled-components";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { fontConfig } from "@stoneage/XDL/constants";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    cssOverrides: {
        scrim: css`
            &&& {
                height: initial;
                background-color: ${color("common.ui4")};
                z-index: 1;
            }
        `,
        drawerContainer: css`
            background-color: ${color("common.ui4")};
        `,
        drawerBody: css`
            height: initial;
            background-color: ${color("common.ui4")};
            padding: 16px 34px;
            box-shadow: none;
        `,
        drawerTitle: css`
            background-color: ${color("common.ui4")};
            padding: 0;
            min-height: 0;
            margin-bottom: 20px;
            ${xScreen("lte", "sm")} {
                margin-bottom: 16px;
            }
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {};

productCompareFlyOutStyles.carouselSlideGridItem = {
    width: 12,
};

productCompareFlyOutStyles.headerCompareButton = {
    sizeVariant: "small",
    css: css`
        justify-content: center;
        ${xScreen("lte", "xs")} {
            flex: 1;
        }
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    variant: "secondary",
    buttonType: "outline",
    sizeVariant: "small",
    css: css`
        margin-right: 24px;
        ${xScreen("lte", "xs")} {
            flex: 1;
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    css: css`
        padding: 0;
        &:hover ${IconWrapper} {
            color: ${color("primary")};
        }
    `,
};

productCompareFlyOutStyles.removeProductFromCompareButtonIcon = {
    color: "common.ui8",
    size: 15,
    css: css`
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
    `,
};
